<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
       <ul class="page-breadcrumb__trail">
          <li><a>Charts</a></li>
          <li><a>Trend Analysis</a></li>
          <li><a>Analytics</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <!-- breadcrumb End -->
      <div class="block">
        <div class="screen_heading_div">
          <span>Analytics</span>
        </div>
        <div class="nav_tabs_container">
          <ul>
            <li (click)="readingsTab()" class="active" data-toggle="tab"><a href="#reading">Water Quality</a></li>
            <li (click)="growthTab()" data-toggle="tab"><a href="#growth">Growth</a></li>
            <li (click)="compareTab()" data-toggle="tab"><a href="#compare">Compare</a></li>
          </ul>
        </div>
        <div class="row" style="padding: 20px 0 10px 0">
          <div class="col-xs-12">
            <div class="col-xs-9">
              <div class="row daysBlock">
                <input type="button" class="readingsdays" value="Show Last 7 Days"
                       (click)="selectedDateReading('seven');"
                       [ngClass]="noOfDays=='seven'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Show Last 30 Days"
                       (click)="selectedDateReading('thirty');"
                       [ngClass]="noOfDays=='thirty'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Show Last 100 Days"
                       (click)="selectedDateReading('hundred');"
                       [ngClass]="noOfDays=='hundred'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="{{currentDay}}"
                       (click)="selectedDateReading('today');"
                       [ngClass]="noOfDays=='today'?'selected-btn':'unselected-btn'">
                <label class="radio-inline"><input type="checkbox" name="currentculture" [value]="true"
                                                   style="margin-right: 10px;" [(ngModel)]="dayOrCulture"
                                                   (change)="prepareGlobalData()">Current
                  Culture</label>
              </div>
              <div class="row parameterBlock" *ngIf="tabIndex==0">
                <label class="paramlabel"><input type="checkbox" name="gap" [(ngModel)]="metric.all"
                                                 (change)="checkAllData()">Check
                  All</label>
                <label class="paramlabel"><input type="checkbox" name="ph" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.ph">pH</label>
                <label class="paramlabel"><input type="checkbox" name="do" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.do">DO</label>
                <label class="paramlabel"><input type="checkbox" name="salinty" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.Salinity">Salinity</label>
                <label class="paramlabel"><input type="checkbox" name="temp" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.temp">Temperature</label>
                <label class="paramlabel"><input type="checkbox" name="tan" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.Tan">TAN</label>
                <label class="paramlabel"><input type="checkbox" name="U.Ammonia" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.Uammonia">U.Ammonia</label>
                <label class="paramlabel"><input type="checkbox" name="nitrite" [(ngModel)]="metric.custNitrite">Nitrite</label>
                <label class="paramlabel"><input type="checkbox" name="alkalinity" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.custalkalinity">Alkalinity</label>
                <label class="paramlabel"><input type="checkbox" name="Biofloc" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.biofloc">Biofloc</label>
                <label class="paramlabel"><input type="checkbox" name="ORP" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.Orp">ORP</label>
                <label class="paramlabel"><input type="checkbox" name="TDS" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.Tds">TDS</label>
                <label class="paramlabel"><input type="checkbox" name="Turbidity" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.Turbidity">Turbidity</label>
                <label class="paramlabel"><input type="checkbox" name="Carbonate" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.Carbonate">Carbonate</label>
                <label class="paramlabel"><input type="checkbox" name="Bicarbonate" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.bicorbonate">Bicarbonate</label>
                <label class="paramlabel"><input type="checkbox" name="hardness" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.custhardness">Total
                  Hardness</label>
                <label class="paramlabel"><input type="checkbox" name="calcium" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.custcalcium">Calcium</label>
                <label class="paramlabel"><input type="checkbox" name="magnesium" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.magnisium">Magnesium</label>
              </div>
              <div class="row parameterBlock" *ngIf="tabIndex==1">
                <label class="paramlabel"><input type="checkbox" name="growthall" [(ngModel)]="metric.growthAll"
                                                 (click)="growthcheckAllData()">Check
                  All</label>
                <label class="paramlabel"><input type="checkbox" name="abw" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.ABW">Average Body
                  Weight(ABW)</label>
                <label class="paramlabel"><input type="checkbox" name="adg" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.ADG">Average Daily
                  Growth(ADG)</label>
                <label class="paramlabel"><input type="checkbox" name="sr" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.sr">Survival
                  Rate(SR%)</label>
                <label class="paramlabel"><input type="checkbox" name="tbm" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.tbm">Total
                  Biomass(TBM)</label>
                <label class="paramlabel"><input type="checkbox" name="fcr" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.fcr">Feed Conversion
                  Ratio(FCR)</label>
                <label class="paramlabel"><input type="checkbox" name="dcf" (change)="uncheckParam()"
                                                 [(ngModel)]="metric.dcf">Day Cumulative
                  Feed</label>
              </div>
              <div class="row parameterBlock" *ngIf="tabIndex==2">
                <div class="row col-xs-12 col-md-5 readingBlock">
                  <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                     (change)="vsParamChange('pH', 'phreading')"
                                                     [(ngModel)]="phreading">pH</label>
                  <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                     (change)="vsParamChange('do2', 'doreading')"
                                                     [(ngModel)]="doreading">DO</label>
                  <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                     (change)="vsParamChange('salinity', 'salinityreading')"
                                                     [(ngModel)]="salinityreading">Salinity</label>
                  <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                     (change)="vsParamChange('temperature', 'tempreading')"
                                                     [(ngModel)]="tempreading">Temperature</label>
                  <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                     (change)="vsParamChange('tan', 'tanreading')"
                                                     [(ngModel)]="tanreading">TAN</label>
                  <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                     (change)="vsParamChange('uam', 'uammoniareading')"
                                                     [(ngModel)]="uammoniareading">U.Ammonia</label>
                  <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                     (change)="vsParamChange('Nitrite', 'nitritereading')"
                                                     [(ngModel)]="nitritereading">Nitrite</label>
                  <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                     (change)="vsParamChange('Alkalinity', 'alkalinityreading')"
                                                     [(ngModel)]="alkalinityreading">Alkalinity</label>
                  <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                     (change)="vsParamChange('Bio_Floc', 'bioflocreading')"
                                                     [(ngModel)]="bioflocreading">Biofloc</label>
                </div>
                <div class="col-xs-12 col-md-1 vsImage">
                  <p><img src="../../../../../assets/img/Vs.svg" width="30"/></p>
                </div>
                <div class="row col-xs-12 col-md-6 growthBlock">
                  <label class="vsparamlabel"><input type="checkbox" name="abwgrowth"
                                                     (change)="vsParamChange('abw', 'abwGrowth')"
                                                     [(ngModel)]="abwGrowth">Average Body Weight(ABW)</label>
                  <label class="vsparamlabel"><input type="checkbox" name="adggrowth"
                                                     (change)="vsParamChange('adg', 'adgGrowth')"
                                                     [(ngModel)]="adgGrowth">Average Daily Growth(ADG)</label>
                  <label class="vsparamlabel"><input type="checkbox" name="srgrowth"
                                                     (change)="vsParamChange('survival_rate', 'srGrowth')"
                                                     [(ngModel)]="srGrowth">Survival Rate(SR%)</label>
                  <label class="vsparamlabel"><input type="checkbox" name="tbmgrowth"
                                                     (change)="vsParamChange('total_biomass', 'tbmGrowth')"
                                                     [(ngModel)]="tbmGrowth">Total Biomass(TBM)</label>
                  <label class="vsparamlabel"><input type="checkbox" name="fcrgrowth"
                                                     (change)="vsParamChange('FCR', 'fcrGrowth')"
                                                     [(ngModel)]="fcrGrowth">Feed Conversion Ratio(FCR)</label>
                  <label class="vsparamlabel"><input type="checkbox" name="cfgrowth"
                                                     (change)="vsParamChange('cumulative_feed', 'dcfGrowth')"
                                                     [(ngModel)]="dcfGrowth">Day Cumulative Feed</label>
                </div>
              </div>
              <div *ngIf="!pgLoad">
                <div class="adjust loader-container">
                  <div class="loader2"></div>
                </div>
              </div>
              <div [hidden]="!pgLoad" *ngIf="tabIndex == 0 && ((checkedIDs && checkedIDs.length>0) && phChartDisp == false)">
                <p class="noDataText">No Data</p>
              </div>
              <div class="row graphBlock" *ngIf="tabIndex == 0"
                   [ngClass]="((!phChartDisp) || !isSearchClicked || !chartGlobalData.length > 0) ?'noDispCls':''">
                <div class="row">
                  <p class="graphHeading"><i>Maximum 100 records</i></p>
                </div>
                <!--ph graph-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.ph && !metric.all) || !phChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>pH (mol/ltr)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('ph')" data-toggle="modal"
                                 data-target="#popUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('ph')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('pH')">Add to Compare</button>
                        </div>
                        <div class="x_content main dragscroll">
                          <div class="" id="phCanvas-container">
                            <canvas id="phCanvasID"></canvas>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--temperature-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.temp && !metric.all) || !tempChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Temperature (<sup>o</sup>C)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('temp')" data-toggle="modal"
                                 data-target="#tempPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('temp')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('temperature')">Add to Compare</button>
                        </div>
                        <div class="x_content main dragscroll">
                          <div class="" id="tempCanvas-container">
                            <canvas id="tempCanvasID"></canvas>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--salinity graph-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.Salinity && !metric.all) || !salinityChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Salinity (ppt)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('salinity')" data-toggle="modal"
                                 data-target="#salinityPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('salinity')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('salinity')">Add to Compare</button>
                        </div>
                        <div class="" id="salinityCanvas-container">
                          <canvas id="salinityCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--amonia graph-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.Uammonia && !metric.all) || !uammoniaChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>U Ammonia (mol/ltr)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('ammonia')" data-toggle="modal"
                                 data-target="#ammoniaPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('ammonia')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('ammonia')">Add to Compare</button>
                        </div>
                        <div class="" id="ammoniaCanvas-container">
                          <canvas id="ammoniaCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Do2-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.do && !metric.all) || !doChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Do (ppm)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('do')" data-toggle="modal"
                                 data-target="#doPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('do')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('do2')">Add to Compare</button>
                        </div>
                        <div class="" id="doCanvas-container">
                          <canvas id="doCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--alkalinity-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.custalkalinity && !metric.all) || !alkalinityChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Alkalinity (ppm)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('alkalinity')" data-toggle="modal"
                                 data-target="#alkalinityPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('alkalinity')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('alkalinity')">Add to Compare</button>
                        </div>
                        <div class="" id="alkalinityCanvas-container">
                          <canvas id="alkalinityCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--biofloc-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.biofloc && !metric.all) || !bioflocChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Biofloc (Mg/Ltr)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('biofloc')" data-toggle="modal"
                                 data-target="#bioflocPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('biofloc')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('Bio_Floc')">Add to Compare</button>
                        </div>
                        <div class="" id="bioflocCanvas-container">
                          <canvas id="bioflocCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--calcium-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.custcalcium && !metric.all) || !calciumChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Calcium (ppm)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('calcium')" data-toggle="modal"
                                 data-target="#calciumPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('calcium')">X</span>
                          </div>
                        </div>
                        <div class="" id="calciumCanvas-container">
                          <canvas id="calciumCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--carbonate-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.Carbonate && !metric.all) || !carbonateChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Carbonate (ppm)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('carbonate')" data-toggle="modal"
                                 data-target="#carbonatePopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('carbonate')">X</span>
                          </div>
                        </div>
                        <div class="" id="carbonateCanvas-container">
                          <canvas id="carbonateCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--hardness-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.custhardness && !metric.all) || !hardnessChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Hardness (ppm)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('hardness')" data-toggle="modal"
                                 data-target="#hardnessPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('hardness')">X</span>
                          </div>
                        </div>
                        <div class="" id="hardnessCanvas-container">
                          <canvas id="hardnessCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--magnesium-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.magnisium && !metric.all) || !magnesimChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Magnesium (ppm)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('magnesium')" data-toggle="modal"
                                 data-target="#magnesiumPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('magnesium')">X</span>
                          </div>
                        </div>
                        <div class="" id="magnesiumCanvas-container">
                          <canvas id="magnesiumCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Nitrite-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.custNitrite && !metric.all) || !nitriteChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Nitrite (ppm)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('nitrite')" data-toggle="modal"
                                 data-target="#nitritePopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('nitrite')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('nitrite')">Add to Compare</button>
                        </div>
                        <div class="" id="nitriteCanvas-container">
                          <canvas id="nitriteCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--orp-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.Orp && !metric.all) || !orpChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>ORP (mV)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('orp')" data-toggle="modal"
                                 data-target="#orpPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('orp')">X</span>
                          </div>
                        </div>
                        <div class="" id="orpCanvas-container">
                          <canvas id="orpCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--turbidity-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.Turbidity && !metric.all) || !turbidityChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Turbidity (ntu)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('turbidity')" data-toggle="modal"
                                 data-target="#turbidityPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('turbidity')">X</span>
                          </div>
                        </div>
                        <div class="" id="turbidityCanvas-container">
                          <canvas id="turbidityCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--tan-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.Tan && !metric.all) || !tanChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>TAN (ppm)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('tan')" data-toggle="modal"
                                 data-target="#tanPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('tan')">X</span>
                          </div>
                        </div>
                        <div class="" id="tanCanvas-container">
                          <canvas id="tanCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--tds-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.Tds && !metric.all) || !tdsChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>TDS</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('tds')" data-toggle="modal"
                                 data-target="#tdsPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('tds')">X</span>
                          </div>
                        </div>
                        <div class="" id="tdsCanvas-container">
                          <canvas id="tdsCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--bicorbonate-->
                <div class="row">
                  <div class="col-xs-12">
                    <div
                      [ngClass]="((!metric.bicorbonate && !metric.all)|| !bicorbonateDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Bi-carbonate (ppm)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('bicarbonate')" data-toggle="modal"
                                 data-target="#bicarbonatePopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('bicarbonate')">X</span>
                          </div>
                        </div>
                        <div class="" id="bicarbonateCanvas-container">
                          <canvas id="bicarbonateCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--graphs end-->
              </div>
              <div [hidden]="!pgLoad"
                   *ngIf="tabIndex == 1 && ((checkedIDs && checkedIDs.length>0) && abwChartDisp == false)">
                <p class="noDataText">No Data</p>
              </div>
              <div class="row graphBlock" *ngIf="tabIndex == 1"
                   [ngClass]="((!abwChartDisp ) || !isSearchClicked) ?'noDispCls':''">
                <!--abw-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.ABW && !metric.growthAll) || !abwChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>ABW (Grams)</span>
                          </div>
                          <div class="col-xs-1">
                            <img (click)="newChart('abw')" data-toggle="modal"
                                 data-target="#abwPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('abw')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('abw')">Add to Compare</button>
                        </div>
                        <div class="" id="abwCanvas-container">
                          <canvas id="abwCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--adg-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.ADG && !metric.growthAll) || !adgChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>ADG (Grams)</span>
                          </div>
                          <div class="col-xs-1">
                            <!--<button (click)="newChart('adg')" data-toggle="modal" data-target="#adgPopUpModal">Zoom
                            </button>-->
                            <img (click)="newChart('adg')" data-toggle="modal"
                                 data-target="#adgPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('adg')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('adg')">Add to Compare</button>
                        </div>
                        <div class="" id="adgCanvas-container">
                          <canvas id="adgCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--sr-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.sr && !metric.growthAll) || !srChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Survival Rate (%)</span>
                          </div>
                          <div class="col-xs-1">
                            <!--<button (click)="newChart('survival_rate')" data-toggle="modal" data-target="#srPopUpModal">
                              Zoom
                            </button>-->
                            <img (click)="newChart('survival_rate')" data-toggle="modal"
                                 data-target="#srPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('survival_rate')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('survival_rate')">Add to Compare</button>
                        </div>
                        <div class="" id="srCanvas-container">
                          <canvas id="srCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--fcr-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.fcr && !metric.growthAll) || !fcrChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>FCR</span>
                          </div>
                          <div class="col-xs-1">
                            <!--<button (click)="newChart('fcr')" data-toggle="modal" data-target="#fcrPopUpModal">Zoom
                            </button>-->
                            <img (click)="newChart('fcr')" data-toggle="modal"
                                 data-target="#fcrPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('fcr')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('fcr')">Add to Compare</button>
                        </div>
                        <div class="" id="fcrCanvas-container">
                          <canvas id="fcrCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--day cumulative feed-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.dcf && !metric.growthAll) || !dcfChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Day Cumulative Feed (Kgs)</span>
                          </div>
                          <div class="col-xs-1">
                            <!--<button (click)="newChart('dcf')" data-toggle="modal" data-target="#dcfPopUpModal">Zoom
                            </button>-->
                            <img (click)="newChart('dcf')" data-toggle="modal"
                                 data-target="#dcfPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('dcf')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('cumulative_feed')">Add to Compare</button>
                        </div>
                        <div class="" id="dcfCanvas-container">
                          <canvas id="dcfCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--tbm-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!metric.tbm && !metric.growthAll) || !tbmChartDisp) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="row heading">
                          <div class="col-xs-10">
                            <span>Total Biomass (Kgs)</span>
                          </div>
                          <div class="col-xs-1">
                            <!--<button (click)="newChart('tbm')" data-toggle="modal" data-target="#tbmPopUpModal">Zoom
                            </button>-->
                            <img (click)="newChart('tbm')" data-toggle="modal"
                                 data-target="#tbmPopUpModal"
                                 src="../../../../../assets/img/icons/zoom_in.svg" height="20" width="20"/>
                          </div>
                          <div class="col-xs-1">
                            <span class="closeParam" (click)="closeParams('tbm')">X</span>
                          </div>
                        </div>
                        <div class="row addToCompare">
                          <button (click)="compareButton('total_biomass')">Add to Compare</button>
                        </div>
                        <div class="" id="tbmCanvas-container">
                          <canvas id="tbmCanvasID"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--graphs end-->
              </div>
              <div [hidden]="!pgLoad"
                   *ngIf="tabIndex == 2 && ((metric.pondId) && compareChartDisplay == false)">
                <p class="noDataText">No Data</p>
              </div>
              <div class="row comparegraphBlock" *ngIf="tabIndex == 2"
                   [ngClass]="((!compareChartDisplay ) || !isSearchClicked) ?'noDispCls':''">
                <!--campare graph-->
                <div class="row">
                  <div class="col-xs-12">
                    <div [ngClass]="((!readingParam && !growthParam) || !compareChartDisplay) ?'noDispCls':''">
                      <div class="x_chart_panel">
                        <div class="heading">
                          <span>{{readingParam | titlecase}} Vs {{growthParam | titlecase}}</span>
                        </div>
                        <div class="x_content main dragscroll">
                          <canvas #compareCanvas></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--graphs end-->
              </div>
            </div>
            <div class="col-xs-3">
              <div class="row top-field">
                <div class="col-md-12" *ngIf="loginPersonType == 'EMPLOYEE'">
                  <div class="form-group cursor-pointer" style="margin-top: 10px;">
                    <label class="control-label">Business</label>
                    <ng-autocomplete [(ngModel)]="item" [data]="businessEntites" [searchKeyword]="keyword"
                                     *ngIf="appPermission[0].farmSelection"
                                     (change)="metric.farm_site_id = undefined; metric.section_id = undefined; activepondsDetails_dropdown = [];"
                                     name="business" (selected)='selectEvent($event)'
                                     (inputChanged)='onChangeSearch($event)'
                                     (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate"
                                     [notFoundTemplate]="notFoundTemplate" placeholder="Enter the Business Name">
                    </ng-autocomplete>
                    <ng-template #itemTemplate let-item><a [innerHTML]="item.businessName"></a></ng-template>
                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group cursor-pointer">
                    <label class="control-label">Farm Site</label>
                    <select name="farmsite" [(ngModel)]="metric.farm_site_id"
                            (change)="getSetionsByFarmsiteId(metric.farm_site_id); farmSiteChange(); compareTemp = []; selectedItemsList = []; metric.section_id = undefined; activepondsDetails_dropdown = [];"
                            class="form-control select">
                      <option value="undefined" disabled selected>Select Farm Site</option>
                      <option value="{{farmSite.id}}"
                              *ngFor="let farmSite of farmsites">{{farmSite.farmNameAtLocation}}</option>
                    </select>
                    <span class="caret history-caret"></span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group cursor-pointer">
                    <label class="control-label">Section</label>
                    <select name="section" [(ngModel)]="metric.section_id"
                            (change)="getPondsBySectionId(metric.section_id); selectedDateReading(noOfDays)"
                            class="form-control select">
                      <option value="undefined" disabled selected>Select Section</option>
                      <option value="{{section.id}}"
                              *ngFor="let section of pondSections">{{section.section_name}}</option>
                    </select>
                    <span class="caret history-caret"></span>
                  </div>
                </div>
                <div class="col-md-12"
                     *ngIf="tabIndex != 2 && (activepondsDetails_dropdown && activepondsDetails_dropdown.length > 0)">
                  <div class="form-group cursor-pointer pondsScroll"
                       [ngClass]="{'pondsScroll' : activepondsDetails_dropdown && activepondsDetails_dropdown.length>20 }">
                    <label class="control-label">Tank Name - Doc</label>
                    <ul class="checkbox-items">
                      <li *ngFor="let item of activepondsDetails_dropdown">
                        <input type="checkbox" name="pond" class="pondname" [(ngModel)]="item.isChecked"
                               (change)="prepareChart();fetchSelectedItems() ">{{item.pond_name}} - <i
                        style="font-size: 13px; color: #ccc;">{{item.doc}} Days</i>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-12"
                     *ngIf="tabIndex == 2 && (activepondsDetails_dropdown && activepondsDetails_dropdown.length > 0)">
                  <div class="form-group cursor-pointer pondsScroll"
                       [ngClass]="{'pondsScroll' : activepondsDetails_dropdown && activepondsDetails_dropdown.length>20 }">
                    <label class="control-label">Tank Name - Doc</label>
                    <ul class="checkbox-items">
                      <li *ngFor="let item of activepondsDetails_dropdown">
                        <input type="radio" [value]="item.pond_id" name="pond" class="pondname"
                               [(ngModel)]="metric.pondId" (change)="prepareChart();">{{item.pond_name}} - <i
                        style="font-size: 13px; color: #ccc;">{{item.doc}} Days</i>
                      </li>
                    </ul>
                  </div>
                </div>
                <p style="color: red"
                   *ngIf="activepondsDetails_dropdown && activepondsDetails_dropdown.length == 0 && metric.section_id != undefined">
                  Tanks are not available for this site</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row result" [hidden]="!(compareTemp && compareTemp.length > 0)">
          <p *ngFor="let item of selectedItemsList">Tank Name: {{item.pond_name}}</p>
          <p *ngFor="let param of compareTemp; let i = index;" class="selectParam">Param {{i + 1}}
            : {{param | titlecase}} <span
              (click)="removeParam(i)" title="Delete card" class="deletebtn">x</span></p>
          <p [hidden]="!(compareTemp && compareTemp.length == 1)">Add one more parameter to compare</p>
          <button [hidden]="!(compareTemp && compareTemp.length == 2)" (click)="viewGraph(compareTemp)"
                  class="viewcomparebtn">View
          </button>
        </div>
      </div>
      <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog modal-lg paramModal">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal" (click)="closepopup()">&times;</button>
              <h4 class="modal-title">Compare</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="col-xs-9">
                    <div class="row daysBlock">
                      <input type="button" class="readingsdays" value="Show Last 7 Days"
                             (click)="selectedDateReading('seven');"
                             [ngClass]="noOfDays=='seven'?'selected-btn':'unselected-btn'">
                      <input type="button" class="readingsdays" value="Show Last 30 Days"
                             (click)="selectedDateReading('thirty');"
                             [ngClass]="noOfDays=='thirty'?'selected-btn':'unselected-btn'">
                      <input type="button" class="readingsdays" value="Show Last 100 Days"
                             (click)="selectedDateReading('hundred');"
                             [ngClass]="noOfDays=='hundred'?'selected-btn':'unselected-btn'">
                      <input type="button" class="readingsdays" value="{{currentDay}}"
                             (click)="selectedDateReading('today');"
                             [ngClass]="noOfDays=='today'?'selected-btn':'unselected-btn'">
                      <label class="radio-inline"><input type="checkbox" name="currentculture" [value]="true"
                                                         style="margin-right: 10px;" [(ngModel)]="dayOrCulture"
                                                         (change)="prepareGlobalData()">Current
                        Culture</label>
                    </div>
                    <div class="row parameterBlock">
                      <div class="row col-xs-12 col-md-5 readingBlock">
                        <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                           (change)="vsPopUpParamChange('pH', 'pHPopUpreading')"
                                                           [(ngModel)]="pHPopUpreading">pH</label>
                        <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                           (change)="vsPopUpParamChange('do2', 'doPopUpreading')"
                                                           [(ngModel)]="doPopUpreading">DO</label>
                        <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                           (change)="vsPopUpParamChange('salinity', 'salinityPopUpreading');"
                                                           [(ngModel)]="salinityPopUpreading">Salinity</label>
                        <label class="vsparamlabel"><input type="checkbox" name="reading" [(ngModel)]="tempPopUpreading"
                                                           [checked]="tempPopUpreading"
                                                           (change)="vsPopUpParamChange('temperature', 'tempPopUpreading');">Temperature</label>
                        <label class="vsparamlabel"><input type="checkbox" name="reading" [(ngModel)]="tanPopUpreading"
                                                           (change)="vsPopUpParamChange('tan', 'tanPopUpreading')">TAN</label>
                        <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                           [(ngModel)]="uammoniaPopUpreading"
                                                           (change)="vsPopUpParamChange('uam', 'uammoniaPopUpreading')">U.Ammonia</label>
                        <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                           [(ngModel)]="nitritePopUpreading"
                                                           (change)="vsPopUpParamChange('Nitrite', 'nitritePopUpreading')">Nitrite</label>
                        <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                           [(ngModel)]="alkalinityPopUpreading"
                                                           (change)="vsPopUpParamChange('Alkalinity', 'alkalinityPopUpreading')">Alkalinity</label>
                        <label class="vsparamlabel"><input type="checkbox" name="reading"
                                                           [(ngModel)]="bioflocPopUpreading"
                                                           (change)="vsPopUpParamChange('Bio_Floc', 'bioflocPopUpreading')">Biofloc</label>
                      </div>
                      <div class="col-xs-12 col-md-1 vsImage">
                        <p><img src="../../../../../assets/img/Vs.svg" width="30"/></p>
                      </div>
                      <div class="row col-xs-12 col-md-6 growthBlock">
                        <label class="vsparamlabel"><input type="checkbox"
                                                           (change)="vsPopUpParamChange('abw', 'abwPopUpGrowth')"
                                                           [(ngModel)]="abwPopUpGrowth">Average Body Weight(ABW)</label>
                        <label class="vsparamlabel"><input type="checkbox"
                                                           (change)="vsPopUpParamChange('adg', 'adgPopUpGrowth')"
                                                           [(ngModel)]="adgPopUpGrowth">Average Daily
                          Growth(ADG)</label>
                        <label class="vsparamlabel"><input type="checkbox" name="growth" [(ngModel)]="srPopUpGrowth"
                                                           (change)="vsPopUpParamChange('survival_rate', 'srPopUpGrowth')">Survival
                          Rate(SR%)</label>
                        <label class="vsparamlabel"><input type="checkbox" name="growth" [(ngModel)]="tbmPopUpGrowth"
                                                           (change)="vsPopUpParamChange('total_biomass', 'tbmPopUpGrowth')">Total
                          Biomass(TBM)</label>
                        <label class="vsparamlabel"><input type="checkbox" name="growth" [(ngModel)]="fcrPopUpGrowth"
                                                           (change)="vsPopUpParamChange('FCR', 'fcrPopUpGrowth')">Feed
                          Conversion
                          Ratio(FCR)</label>
                        <label class="vsparamlabel"><input type="checkbox" name="growth" [(ngModel)]="dcfPopUpGrowth"
                                                           (change)="vsPopUpParamChange('cumulative_feed', 'dcfPopUpGrowth')">Day
                          Cumulative Feed</label>
                      </div>
                    </div>
                    <div
                      *ngIf="((metric.comparepondId) && comparePopUpChartDisplay == false)">
                      <p class="noDataText">No Data</p>
                    </div>
                    <div class="row">
                      <div class="col-xs-12">
                        <div [ngClass]="((!readingParam && !growthParam) || !comparePopUpChartDisplay) ?'noDispCls':''">
                          <div class="x_chart_panel">
                            <div class="heading">
                              <span>{{readingParam | titlecase}} Vs {{growthParam | titlecase}}</span>
                            </div>
                            <div class="x_content main dragscroll">
                              <canvas #comparepopUpCanvas></canvas>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-3">
                    <div class="row top-field">
                      <div class="col-md-12">
                        <div class="form-group cursor-pointer" style="margin-top: 10px;">
                          <label class="control-label">Business</label>
                          <select name="business" [(ngModel)]="metric.business_id" class="form-control select"
                                  
                                  (change)="getAllFarmsitesBybusinessId(); metric.section_id = undefined; activepondsDetails_dropdown = [];"
                                  required>
                            <option value="undefined">Select Business</option>
                            <option value="{{business.id}}"
                                    *ngFor="let business of businessEntites">{{business.businessName}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group cursor-pointer">
                          <label class="control-label">Farm Site</label>
                          <select name="farmsite" [(ngModel)]="metric.farm_site_id"
                                  (change)="getSetionsByFarmsiteId(metric.farm_site_id); farmSiteChange();metric.section_id = undefined; activepondsDetails_dropdown = [];"
                                  class="form-control select">
                            <option value="undefined" disabled selected>Select Farmsite</option>
                            <option value="{{farmSite.id}}"
                                    *ngFor="let farmSite of farmsites">{{farmSite.farmNameAtLocation}}</option>
                          </select>
                          <span class="caret history-caret"></span>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group cursor-pointer">
                          <label class="control-label">Section</label>
                          <select name="section" [(ngModel)]="metric.section_id"
                                  (change)="getPondsBySectionId(metric.section_id)"
                                  class="form-control select">
                            <option value="undefined" disabled selected>Select Section</option>
                            <option value="{{section.id}}"
                                    *ngFor="let section of pondSections">{{section.section_name}}</option>
                          </select>
                          <span class="caret history-caret"></span>
                        </div>
                      </div>
                      <div class="col-md-12"
                           *ngIf="(activepondsDetails_dropdown && activepondsDetails_dropdown.length > 0)">
                        <div class="form-group cursor-pointer pondsScroll"
                             [ngClass]="{'pondsScroll' : activepondsDetails_dropdown && activepondsDetails_dropdown.length>20 }">
                          <label class="control-label">Tank Name - Doc</label>
                          <ul class="checkbox-items">
                            <li *ngFor="let item of activepondsDetails_dropdown">
                              <input type="radio" [value]="item.pond_id" name="popuppond" class="pondname"
                                     [(ngModel)]="metric.comparepondId"
                                     (change)="comparePrepareChart();">{{item.pond_name}} - <i
                              style="font-size: 13px; color: #ccc;">{{item.doc}} Days</i>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <p style="color: red"
                         *ngIf="activepondsDetails_dropdown && activepondsDetails_dropdown.length == 0 && metric.section_id != undefined">
                        Tanks are not available for this site</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="popMyModal" role="dialog">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">Modal Header</h4>
            </div>
            <div class="modal-body">
              <div class="x_content main dragscroll">
                <canvas #poppHCanvas></canvas>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      <!--phmodal popup-->
      <div class="modal fade " id="popUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="modalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="modalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--ph modal popup end-->
      <!--temp modal popup-->
      <div class="modal fade " id="tempPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="tempModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="tempModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--temp modal popup end-->
      <!--salinity modal popup-->
      <div class="modal fade " id="salinityPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="salinityModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="salinityModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--salinity modal popup end-->
      <!--ammonia modal popup-->
      <div class="modal fade " id="ammoniaPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="ammoniaModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="ammoniaModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--ammonia modal popup end-->
      <!--do2 modal popup-->
      <div class="modal fade " id="doPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="doModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="doModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--do2 modal popup end-->
      <!--alkalinity modal popup-->
      <div class="modal fade " id="alkalinityPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="alkalinityModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="alkalinityModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--alkalinity modal popup end-->
      <!--biofloc modal popup-->
      <div class="modal fade " id="bioflocPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="bioflocModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="bioflocModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--biofloc modal popup end-->
      <!--calcium modal popup-->
      <div class="modal fade " id="calciumPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="calciumModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="calciumModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--calcium modal popup end-->
      <!--carbonate modal popup-->
      <div class="modal fade " id="carbonatePopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="carbonateModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="carbonateModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--carbonate modal popup end-->
      <!--hardness modal popup-->
      <div class="modal fade " id="hardnessPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="hardnessModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="hardnessModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--hardness modal popup end-->
      <!--magnesiumPopUpModal-->
      <div class="modal fade " id="magnesiumPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="magnesiumModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="magnesiumModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--magnesiumPopUpModal end-->
      <!--nitrite PopUpModal-->
      <div class="modal fade " id="nitritePopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="nitriteModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="nitriteModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--nitrite PopUpModal end-->
      <!--orpPopUpModal PopUpModal-->
      <div class="modal fade " id="orpPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="orpModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="orpModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--orpPopUpModal PopUpModal end-->
      <!--tanPopUpModal PopUpModal-->
      <div class="modal fade " id="tanPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="tanModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="tanModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--tan PopUpModal end-->
      <!--tds PopUpModal-->
      <div class="modal fade " id="tdsPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="tdsModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="tdsModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--tan PopUpModal end-->
      <!--turbidity PopUpModal-->
      <div class="modal fade " id="turbidityPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="turbidityModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="turbidityModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--bicarbonate PopUpModal end-->
      <!--bicarbonate PopUpModal-->
      <div class="modal fade " id="bicarbonatePopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="bicarbonateModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="bicarbonateModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--bicarbonate PopUpModal end-->
      <!--Growth related modal popup-->
      <!--abw modal popup-->
      <div class="modal fade " id="abwPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="abwModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="abwModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--abw modal popup end-->
      <!--adg modal popup-->
      <div class="modal fade " id="adgPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="adgModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="adgModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--adg modal popup end-->
      <!--sr modal popup-->
      <div class="modal fade " id="srPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="srModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="srModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--sr modal popup end-->
      <!--fcr modal popup-->
      <div class="modal fade " id="fcrPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="fcrModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="fcrModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--fcr modal popup end-->
      <!--day cummulative feed modal popup-->
      <div class="modal fade " id="dcfPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="dcfModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="dcfModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--day cummulative feed modal popup end-->
      <!--total biomass modal popup-->
      <div class="modal fade " id="tbmPopUpModal" role="dialog">
        <div class="modal-dialog modal-lg ">
          <div class="modal-content">
            <div class="modal-body" id="tbmModalCanvas-container">
              <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <canvas id="tbmModalCanvasID"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--total biomass modal popup end-->
      <!--Growth related modal popup end-->
    </div>
  </div>
</div>
